import { to } from "await-to-js";
import http from "../http";
import urls from "../urls";

export default new (class {
  sendIframePost(data) {
    if (data.id) {
      return to(http.post(`${urls.submit.post}/${data.id}`, data.formData));
    }
    return to(http.post(`${urls.iframe.post}`, data.formData));
  }
})();
